// Copy buttons (#1427). The value rides in a data-copy attribute and one listener on the page
// copies it. Never put the value into an inline handler: the HTML parser turns &#039; back into a
// quote before the onclick JavaScript runs, so an escaped lead email could end the string literal
// and run as script in the admin's session.
import { showToast } from "./toast.js";

const ATTRIBUTE_ESCAPES = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };

function escapeAttribute(value) {
  return String(value ?? "").replace(/[&<>"']/g, (c) => ATTRIBUTE_ESCAPES[c]);
}

/** The attributes of a copy button, e.g. `<button type="button" ${copyAttributes(email, "Copied the email.")}>`. */
export function copyAttributes(value, toast, tone = "info") {
  return `data-copy="${escapeAttribute(value)}" data-copy-toast="${escapeAttribute(toast)}" data-copy-tone="${escapeAttribute(tone)}"`;
}

/** Copies a [data-copy] button's value and says so in a toast. */
export function copyFromButton(button, toast = showToast) {
  const { copy = "", copyToast, copyTone } = button.dataset;
  return navigator.clipboard.writeText(copy).then(
    () => toast(copyToast || "Copied.", copyTone || "info"),
    () => toast("Couldn't copy it.", "error")
  );
}

/**
 * One listener for every copy button on the page. It listens in the capture phase and stops the
 * click there, so the table row or card around the button does not open as well.
 */
export function installCopyButtons(root = document, toast = showToast) {
  root.addEventListener(
    "click",
    (event) => {
      const button = event.target?.closest?.("[data-copy]");
      if (!button) return;
      event.stopPropagation();
      copyFromButton(button, toast);
    },
    true
  );
}

/**
 * A string argument for an inline handler that has no data-* form yet, e.g.
 * `onclick="window.crmApp.viewRecipe(${jsArg(id)})"`. JSON makes it a string literal that a
 * decoded quote cannot end, and the escaping keeps it inside the double-quoted attribute.
 */
export function jsArg(value) {
  return escapeAttribute(JSON.stringify(String(value ?? "")));
}
